import { ApolloClient, DocumentNode } from '@apollo/client';
import { getDocumentById } from '../../../api/queries_v2';
import { graphql } from '../../../gql';

type ResponsePayloadType = {
  id: string | number;
};

export const startSigningDocument = ({
  documentId,
  additionalMessage,
}: {
  documentId: string;
  additionalMessage?: string;
}) => {
  return async function (client: ApolloClient<object>): Promise<ResponsePayloadType> {
    try {
      const variables = {
        documentId,
        additionalMessage,
      };

      const mutation = graphql(/* GraphQL */ `
        mutation startSigningDocument($documentId: ID!, $additionalMessage: String) {
          startSigningDocument(documentId: $documentId, additionalMessage: $additionalMessage) {
            id
          }
        }
      `) as DocumentNode;

      const refetchQueries = [
        {
          query: getDocumentById,
          variables: {
            documentId: documentId!,
          },
        },
      ];

      return client
        .mutate({ mutation, variables, refetchQueries })
        .then(({ data }: Record<any, any>) => data.startSigningDocument);
    } catch (error) {
      console.error('Error in startSigningDocument:', error);
      throw error;
    }
  };
};
